const AlertCommentType = {
  USER: 1,
  ROOM_ALERT: 2,
  DELETED: 3,
  RA_USER_ENTERED: 4,
};
// eslint-disable-next-line import/prefer-default-export
export { AlertCommentType };
